import { copy } from "clipboard";

const commonModule = {
  confirm: "确定",
  cancel: "取消",
  home: "主页",
  search: "搜索",
  order: "订单一览",
  coupon: "优惠券一览",
  user: "我的",
  save: "保存",
  isDelete: "是否要删除吗?",
  isCancel: "是否要取消?",
  addSuccess: "新增成功",
  cancelSuccess: "取消成功",
  add: "新增",
  delete: "删除",
  submit: "提交",
  emailFormat: "邮箱格式错误",
  example: "例",
  min: "分",
  noContent: "暂无数据",
  privateBrowse: "当前为无痕模式，请关掉无痕模式，确保功能正常使用",
  back: "返回",
  detail: "详情",
  store: "店铺",
  amount: "金额",
  loading: "加载中...",
  bn: "编号",
  goHome: "返回首页",
  desc1:"正在出售的票",
  agree:"请先同意隐私政策",
  card:"选择信用卡",
  point_list:"景点列表",
  invoice:"请填写内容",
  jpPhone:"日本 +81",
  cnPhone:"中国 +86",
  krPhone:"韩国 +82",
  hkPhone:"香港 +852",
  moPhone:"澳门 +853",
  twPhone:"台湾 +886",
  useNum:"使用数量",
  useSuccess:"利用成功",
  isUse:"要利用吗？",
  couponOrder:"订单号",
  couponCount1:"可使用券数",
  couponCount2:"已使用券数",
  couponCount3:"过期券数",
  couponCount4:"获得券数",
  couponTime:"获得时间",
  couponShop:"店铺名",
  couponAddr:"地址",
  couponStatus1:"未使用",
  couponStatus2:"部分使用",
  couponStatus3:"使用完毕",
  couponStatus4:"已过期",
  close:"关闭",
  comment: "评论",
  copy: "复制",
  copySuccess: "复制成功",
  copyFailed: "复制失败",
};

export default commonModule;
